// extracted by mini-css-extract-plugin
module.exports = {"container":"TextAlignmentControl_container__3b_DX"};